import {createContext, useContext} from "react";
import { TypeIniciative } from "src/components/ModalIniciatives/interface";
import { TabsKRMODAL } from "src/components/OrgChart/keyResults/interface";
import { TabsOKRMODAL } from "src/components/OrgChart/objectives/interface";

interface IHierarchyOrgChartContextProps{
    callbackOnAddOKRHierarchy: (okrParent: number) => Promise<void>;
	callbackOnChangeOKRHierarchy: (id: number) => Promise<void>;
	callbackOnDeleteOKRHierarchy: (id: number) => void;
	openModalAddOrChangeKr?: (id?: number, okrParentId?: number, okrParentTitle?: string, onCallback?: Function, tabInitSelected?: TabsKRMODAL, disabled?: boolean) => void;
	openModalPerformCheckIn?: (krId: number,  krTitle: string, measurementType: string, measurementForm: string, realizedValue: string | number, percent: string | number, colorGraph: string, initialValue?: string | number, goal?: string | number, onCallback?: Function) => void;
	openModalDelete?: (id: number, title: string, onCallback?: Function) => void;
	openModalAddOrChange?: (id?: number, okrParentId?: number, onCallback?: Function, tabInitSelected?: TabsOKRMODAL | undefined) => void;
	openModalOKRComments?: (id: number, titleOkr: string, onCallback?: Function, disabled?: boolean) => void;
	openModalOKRAttachments?: (id: number, titleOkr: string, onCallback?: Function,  disabled?: boolean) => void;
	openModalOKRMissionAndPremises?:(id: number, titleOkr: string) => void;
	openModalIniciatives?: ((typeIniciative: TypeIniciative, subTitle: string, onCallback?: () => void, permissions?: number) => void);
}

export const HierarchyOrgChartContext = createContext<IHierarchyOrgChartContextProps>({} as IHierarchyOrgChartContextProps);

export function useHierarchyOrgChart(): IHierarchyOrgChartContextProps{
	const context = useContext(HierarchyOrgChartContext);

	if(!context){
		throw new Error("useHierarchyOrgChart function must be used inside the HierarchyOrgChart Provider.");
	}

	return context;
}
